import { useMemo } from 'react';

import { mapDetectedBrandTermToHighlightingMark } from 'src/data/brandTerm';

export const useEditorMarks = (detectedBrandTermsData) => {
  const detectedBrandTerms = detectedBrandTermsData?.items;

  return useMemo(() => {
    if (!(detectedBrandTerms?.length > 0)) {
      return [];
    }
    return detectedBrandTerms.map(mapDetectedBrandTermToHighlightingMark);
  }, [detectedBrandTerms]);
};
